export default __webpack_public_path__ + "static/media/text-border-bottom.d1713e81.svg";